import { BrandLogoEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandLogoUnUseRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandLogoUnUseRequestDTO.validationSchema(),
    BrandLogoEntity
  );

  constructor(readonly data: RoomBrandLogoUnUseRequest) {
    JsonSchemaValidator.assert(RoomBrandLogoUnUseRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandLogo"],
      properties: {
        roomId,
        brandLogo: {
          instanceof: BrandLogoEntity.name
        }
      }
    };
  }
}

interface RoomBrandLogoUnUseRequest {
  roomId: RoomId;
  brandLogo: BrandLogoEntity;
}
